<template>
  <div>
    <el-dialog
      :center="true"
      :visible.sync="show"
      :close-on-click-modal="false"
      :modal="true"
      width="auto"
      height="auto"
      :append-to-body="true"
      class="dialog"
    >
      <div class="box">
        <div class="b_head">
          <span>{{ lang.select_app }}</span>
					<svg  @click="close()" t="1748587270371" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5023" width="200" height="200"><path d="M0 0h1024v1024H0z" fill="#FF0033" fill-opacity="0" p-id="5024"></path><path d="M240.448 168l2.346667 2.154667 289.92 289.941333 279.253333-279.253333a42.666667 42.666667 0 0 1 62.506667 58.026666l-2.133334 2.346667-279.296 279.210667 279.274667 279.253333a42.666667 42.666667 0 0 1-58.005333 62.528l-2.346667-2.176-279.253333-279.253333-289.92 289.962666a42.666667 42.666667 0 0 1-62.506667-58.005333l2.154667-2.346667 289.941333-289.962666-289.92-289.92a42.666667 42.666667 0 0 1 57.984-62.506667z" fill="#111111" p-id="5025"></path></svg>
        </div>
        <div class="b_main" v-loading="loading">
					<div
							class="ac_c_item"
							:class="{active:checkId==item.id}"
							v-for="item in dataList"
							:key="item.id"
							@click="selectApp(item)"
						>
							<div class="ac_c_i_top2">
								<div class="ac_c_i_t2_left">
									<div class="ac_c_i_t2_l_avatarArea">
										<img v-if="item.json.icon" :src="item.json.icon" />
										<svg
											v-else
											t="1732605901531"
											class="icon"
											viewBox="0 0 1024 1024"
											version="1.1"
											xmlns="http://www.w3.org/2000/svg"
											p-id="4275"
											width="200"
											height="200"
										>
											<path
												d="M179.2 153.6a51.2 51.2 0 0 0-51.2 51.2v128a51.2 51.2 0 0 0 51.2 51.2h128a51.2 51.2 0 0 0 51.2-51.2V204.8a51.2 51.2 0 0 0-51.2-51.2H179.2z m0-102.4h128a153.6 153.6 0 0 1 153.6 153.6v128a153.6 153.6 0 0 1-153.6 153.6H179.2a153.6 153.6 0 0 1-153.6-153.6V204.8a153.6 153.6 0 0 1 153.6-153.6z m0 614.4a51.2 51.2 0 0 0-51.2 51.2v128a51.2 51.2 0 0 0 51.2 51.2h128a51.2 51.2 0 0 0 51.2-51.2V716.8a51.2 51.2 0 0 0-51.2-51.2H179.2z m0-102.4h128a153.6 153.6 0 0 1 153.6 153.6v128a153.6 153.6 0 0 1-153.6 153.6H179.2a153.6 153.6 0 0 1-153.6-153.6V716.8a153.6 153.6 0 0 1 153.6-153.6z m611.84-403.4048a51.2 51.2 0 0 0-72.3968 0L646.144 232.2432a51.2 51.2 0 0 0 0 72.3968l72.448 72.3968a51.2 51.2 0 0 0 72.3968 0l72.3968-72.3968a51.2 51.2 0 0 0 0-72.3968L791.04 159.744z m72.3968-72.3968l72.3968 72.3968a153.6 153.6 0 0 1 0 217.2416l-72.3968 72.3968a153.6 153.6 0 0 1-217.2416 0l-72.3968-72.3968a153.6 153.6 0 0 1 0-217.2416l72.3968-72.3968a153.6 153.6 0 0 1 217.2416 0zM699.7504 896a51.2 51.2 0 0 1 0 102.4A162.1504 162.1504 0 0 1 537.6 836.2496v-110.8992A162.1504 162.1504 0 0 1 699.7504 563.2h110.8992a162.1504 162.1504 0 0 1 162.1504 162.1504v8.448a51.2 51.2 0 0 1-102.4 0v-8.448c0-33.024-26.7264-59.7504-59.7504-59.7504h-110.8992c-33.024 0-59.7504 26.7264-59.7504 59.7504v110.8992c0 33.024 26.7264 59.7504 59.7504 59.7504z"
												fill="#2C6DD2"
												p-id="4276"
											></path>
											<path
												d="M791.4496 160a51.2 51.2 0 0 0-72.3968 0l-72.448 72.3968a51.2 51.2 0 0 0 0 72.3968l72.448 72.3968a51.2 51.2 0 0 0 72.3968 0l72.3968-72.3968a51.2 51.2 0 0 0 0-72.3968l-72.3968-72.3968z"
												fill="#20C997"
												p-id="4277"
											></path>
										</svg>
									</div>
								</div>
								<div class="ac_c_i_t2_right">
									<div class="ac_c_i_t2_r_top">
										<el-tooltip
											class="item"
											effect="light"
											:content="item.name"
											placement="top"
										>
											<span>{{ item.name }}</span>
										</el-tooltip>
									</div>
									<div class="ac_c_i_t2_r_center">
										<span>{{ item.username }}</span>
										<span>@{{ item.orgName }}</span>
									</div>
									<div class="ac_c_i_t2_r_bottom">
										<span v-if="['agent', 'workflow'].includes(item.label)">{{
											labelSelect.find((i) => i.value === item.label).label
										}}</span>
										<span
											v-if="
												['agent'].includes(item.label) ||
												(['workflow'].includes(item.label) && item.json.modes)
											"
										>
											<template v-if="item.label === 'agent'">{{
												lang.chatMode
											}}</template>
											<template v-else-if="item.json.modes">{{
												wayList[item.json.modes[0]]
											}}</template>
										</span>
										<span v-if="item.tag">
											<img
												v-if="item.tag == '1'"
												src="@/assets/img/appCenter/appManagement/authority_icon.svg"
												alt=""
											/>
											<img
												v-if="item.tag == '2'"
												src="@/assets/img/appCenter/appManagement/winnow_icon.svg"
												alt=""
											/>
											<img
												v-if="item.tag == '3'"
												src="@/assets/img/appCenter/appManagement/exclusive_icon.svg"
												alt=""
											/>

											<template v-if="item.tag == '1'">{{
												lang.authority
											}}</template>
											<template v-if="item.tag == '2'">{{
												lang.winnow
											}}</template>
											<template v-if="item.tag == '3'">{{
												lang.exclusive
											}}</template>
											<template v-if="item.tag == '4'">{{
												lang.organization
											}}</template>
											<template v-if="item.tag == '5'">{{
												lang.personal
											}}</template>
										</span>
									</div>
								</div>
							</div>
							<div class="ac_c_i_center2">
								<div>
									{{ item.detail }}
								</div>
							</div>
							<div class="ac_c_i_bottom2">
								<el-tooltip
									class="item"
									effect="light"
									:content="lang.number_of_users"
									placement="top"
								>
									<div>
										<img
											src="@/assets/img/appCenter/appManagement/user_copy.svg"
										/>
										<span>{{ item.useCount }}</span>
									</div>
								</el-tooltip>
								<span></span>
								<el-tooltip
									class="item"
									effect="light"
									:content="item.likeId ? lang.unlike : lang.isLike"
									placement="top"
								>
									<div>
										<img
											:src="
												require('@/assets/img/appCenter/appManagement/like_icon.svg')
											"
											v-if="!item.likeId"
											style="cursor: pointer"
										/>
										<img
											:src="
												require('@/assets/img/appCenter/appManagement/isLike_icon.svg')
											"
											v-else
											style="cursor: pointer"
										/>
										<span>{{ item.likeCount }}</span>
									</div>
								</el-tooltip>
								<span></span>
								<el-tooltip
									class="item"
									effect="light"
									:content="item.collectId ? lang.cancel_collect : lang.collect"
									placement="top"
								>
									<div>
										<img
											src="@/assets/img/appCenter/appManagement/collect_default.svg"
											v-if="!item.collectId"
											style="cursor: pointer"
										/>
										<img
											src="@/assets/img/appCenter/appManagement/collect_active.svg"
											v-else
											style="cursor: pointer"
										/>
										<span>{{ item.collectCount }}</span>
									</div>
								</el-tooltip>
							</div>
						</div>
        </div>
        <div class="b_bottom">
          <el-button size="small" @click="close()">{{ lang.cancel }}</el-button>
          <el-button size="small" type="primary" @click="submit"
            >{{ lang.queding }}</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      show: false,
			dataList:[],
			wayList: [
				this.lang.chatMode,
				this.lang.File_generation,
				this.lang.immersion,
			],
			labelSelect: [
				{ value: "", label: this.lang.allTypes },
				{ value: "agent", label: this.lang.intelligent_agents },
				{ value: "workflow", label: this.lang.workflow },
			],
			checkId:null,
    };
  },
  methods: {
    open(id) {
      this.init();
      this.loading = false;
			this.getData();
      this.show = true;
			this.checkId = id?id:null;
    },
    close() {
      this.show = false;
      this.init();
    },
    init() {
      this.dataList = [];
    },
		getData() {
			this.loading = true;
			let params = {
				uid: this.userId?this.userId:this.$store.state.user.userId, //用户ID
				name: "", //应用名称搜索
				label: "", //应用的标签搜索
				type: "", //应用的类型
				juri: 1, //应用权限 1:我的  2：组织内  3：所有人
				stand: this.user.orgArea ? this.user.orgArea : "cn", //cn站还是hk站
				status: "",
				model: "",
				exportType:"",
			};
			this.ajax
				.get(this.$store.state.api + "select_appStore_exportType2", params)
				.then((res) => {
					//防止请求过快并请求延迟
					this.loading = false;
					let _data = res.data[0];
					if (_data.length > 0) {
						_data.forEach((i) => {
							if (i.json) {
								i.json = JSON.parse(i.json);
							}
						});
						_data.sort((a, b) => new Date(b.create_at) - new Date(a.create_at));
						this.dataList = _data;
					} else {
						this.dataList = [];
					}
				})
				.catch(() => {
					this.loading = false;
					this.$message.error(this.lang.Failed_to_obtain_application);
				});
		},
    submit() {
      let _data = JSON.parse(JSON.stringify(this.dataList.find((i) => i.id == this.checkId)));
			if(_data){
				this.$emit('success',_data);
			}
    },
		selectApp(item){
			this.checkId = item.id;
		}
  }
};
</script>

<style scoped lang="scss">
.dialog::v-deep(.el-dialog) {
  width: 60vw !important;
	min-width: 1000px;
	border-radius: 8px;
  padding: 0;
  background-color: #fff;
  overflow: hidden;
}

.dialog::v-deep(.el-dialog__body) {
	width: 60vw !important;
	min-width: 1000px;
  height: auto;
  flex-shrink: 0;
  padding: 0;
  box-sizing: border-box;
  overflow: auto;
}

.dialog::v-deep(.el-dialog__header) {
  display: none !important;
}

.box {
	width: 60vw !important;
	min-width: 1000px;
  height: 60vh;
	min-height: 800px;
  background: #fafafa;
  border-radius: 15px;
  box-shadow: 0px 6px 30px 5px rgba(0, 0, 0, 0.05),
    0px 16px 24px 2px rgba(0, 0, 0, 0.04), 0px 8px 10px -5px rgba(0, 0, 0, 0.08);
}

.b_head {
  width: 100%;
  height: 50px;
  border-radius: 15px 15px 0 0;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 20px;
}

.b_head > span {
  font-size: 18px;
  font-weight: bold;
  color: #000;
}

.b_head > img {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.b_head > svg {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.b_main {
  width: 100%;
  height: calc(100% - 50px - 70px);
  background: #fafafa;
  padding: 20px 20px 0 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  // justify-content: space-around;
	flex-wrap: wrap;
	overflow: auto;
}

.b_bottom {
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  box-sizing: border-box;
  padding: 0 20px;
}

.active{
	border-color: #409EFF !important;
}

.ac_c_item,.comItem,.tableClass {
	width: calc(100% / 4 - (15px * 4) / 4);
	height: 225px;
	background-color: #fff;
	border-radius: 10px;
	box-sizing: border-box;
	padding: 15px;
	margin-right: 15px;
	margin-bottom: 15px;
	float: left;
	border: solid 1px #e7e7e7;
	transition: 0.2s;
	display: flex;
	flex-direction: column;
	cursor: pointer;
	.ac_c_i_top2 {
		width: 100%;
		height: 100px;
		margin-bottom: 5px;
		display: flex;
		.ac_c_i_t2_left {
			width: 62px;
			height: 62px;

			.ac_c_i_t2_l_avatarArea {
				width: 100%;
				height: 100%;
				border-radius: 2px;
				overflow: hidden;
				img {
					width: 100%;
					height: 100%;
					object-fit: cover;
				}
				svg {
					width: 100%;
					height: 100%;
					object-fit: cover;
				}
			}
		}
		.ac_c_i_t2_right {
			margin-left: 10px;
			width: calc(100% - 62px - 10px);
			display: flex;
			flex-direction: column;
			// justify-content: space-between;
			// align-items: ;
			.ac_c_i_t2_r_top {
				width: 100%;
				height: 30px;
				display: flex;
				// align-items: flex-start;
				justify-content: space-between;
				align-items: center;
				line-height: 30px;
				span {
					display: block;
					font-weight: bold;
					font-size: 18px;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
					// max-width: calc(100% - 60px);
				}
			}

			.ac_c_i_t2_r_center {
				width: 100%;
				height: 30px;
				display: flex;
				align-items: center;
				margin-bottom: 8px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;

				span {
					font-size: 14px;
					color: #00000066;
					margin-right: 10px;
				}
			}
			.ac_c_i_t2_r_bottom {
				width: 100%;
				display: flex;
				overflow: hidden;
				&:hover{
					overflow: auto;
				}
				span {
					font-size: 14px;
					margin-right: 10px;
					padding: 4px 6px;
					background-color: #f3f7fd;
					color: #000000b8;
					font-weight: 500;
					border-radius: 4px;
					text-align: center;
					white-space: nowrap;
					img {
						width: 16px;
						height: 16px;
						position: relative;
						top: 3px;
						margin-right: 3px;
					}
				}
			}
		}
	}
	.ac_c_i_center2 {
		width: 100%;
		height: 55px;
		margin-top: 5px;
		div {
			font-size: 14px;
			color: #00000099;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 2;
			overflow: hidden;
			text-overflow: ellipsis;
		}
		// background-color: yellow;
	}
	.ac_c_i_bottom2 {
		width: 100%;
		height: 30px;
		box-sizing: border-box;
		border-top: solid 1px #f3f3f3;
		display: flex;
		align-items: center;
		justify-content: space-around;
		padding-top: 15px;
		cursor: default;
		& > span {
			width: 2px;
			height: 140%;
			background-color: #f3f3f3;
		}
		div {
			display: flex;
			align-items: center;
			font-size: 12px;
			cursor: pointer;
			img {
				height: 18px;
			}
			span {
				margin-left: 5px;
				background-color: none !important;
			}
		}
	}
}


</style>
